export const GET_SALES_LIST = 'GET_SALES_LIST';
export const GET_SALES_ID = 'GET_SALES_ID';

export const POST_SALES_SAVE = 'POST_SALES_SAVE';
export const POST_SALES_DELETE = 'POST_SALES_DELETE';
export const SALES_ERROR = 'SALES_ERROR';
export const GET_SALES_PENDING_ITEMS = 'GET_SALES_PENDING_ITEMS';
